module.exports = __webpack_public_path__ + "static/media/progress_bar.96c566fe.svg";